import React from 'react';
import PageTransition from '../components/ui/PageTransition';
import { motion } from 'framer-motion';

const PrivacyPage: React.FC = () => {
  return (
    <PageTransition>
      <section className="pt-32 pb-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <motion.h1 
              className="text-4xl font-bold text-gray-900"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
            >
              Privacy Policy
            </motion.h1>
            <motion.p 
              className="mt-4 text-gray-600"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
            >
              Last updated: April 19, 2025
            </motion.p>
          </div>
          
          <div className="prose prose-lg mx-auto text-gray-800">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.4 }}
            >
              <h2>1. Introduction</h2>
              <p>
                At AgentSpot, we take your privacy seriously. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our platform, website, and services (collectively, the "Service").
              </p>
              <p>
                Please read this Privacy Policy carefully. By accessing or using the Service, you acknowledge that you have read, understood, and agree to be bound by all the terms of this Privacy Policy.
              </p>

              <h2>2. Information We Collect</h2>
              <h3>2.1 Personal Information</h3>
              <p>
                We may collect personal information that you voluntarily provide to us when you:
              </p>
              <ul>
                <li>Register for an account</li>
                <li>Sign up for our newsletter</li>
                <li>Request customer support</li>
                <li>Participate in surveys or promotions</li>
              </ul>
              <p>
                This information may include:
              </p>
              <ul>
                <li>Name</li>
                <li>Email address</li>
                <li>Company name</li>
                <li>Job title</li>
                <li>Billing information</li>
              </ul>

              <h3>2.2 Usage Data</h3>
              <p>
                We automatically collect certain information when you access or use the Service. This information may include:
              </p>
              <ul>
                <li>IP address</li>
                <li>Browser type</li>
                <li>Operating system</li>
                <li>Pages visited</li>
                <li>Time spent on pages</li>
                <li>Referral source</li>
                <li>Device information</li>
              </ul>

              <h3>2.3 Cookies and Similar Technologies</h3>
              <p>
                We use cookies and similar tracking technologies to track activity on our Service and to hold certain information. Cookies are files with a small amount of data which may include an anonymous unique identifier.
              </p>

              <h2>3. How We Use Your Information</h2>
              <p>
                We may use the information we collect for various purposes, including to:
              </p>
              <ul>
                <li>Provide, maintain, and improve the Service</li>
                <li>Process transactions</li>
                <li>Send administrative information</li>
                <li>Respond to inquiries and offer support</li>
                <li>Send marketing and promotional communications</li>
                <li>Monitor and analyze usage patterns</li>
                <li>Prevent fraudulent transactions and monitor against theft</li>
                <li>Comply with legal obligations</li>
              </ul>

              <h2>4. Disclosure of Your Information</h2>
              <p>
                We may share your information in the following situations:
              </p>
              <ul>
                <li><strong>Service Providers:</strong> We may share your information with third-party vendors, service providers, and other third parties who perform services on our behalf.</li>
                <li><strong>Business Transfers:</strong> We may share or transfer your information in connection with a merger, acquisition, reorganization, sale of assets, or bankruptcy.</li>
                <li><strong>Legal Requirements:</strong> We may disclose your information if required to do so by law or in response to valid requests by public authorities.</li>
              </ul>

              <h2>5. Data Security</h2>
              <p>
                We implement appropriate technical and organizational measures to protect the security of your personal information. However, please be aware that no method of transmission over the Internet or method of electronic storage is 100% secure.
              </p>

              <h2>6. Your Data Protection Rights</h2>
              <p>
                Depending on your location, you may have certain rights regarding your personal information, such as:
              </p>
              <ul>
                <li>The right to access your personal information</li>
                <li>The right to rectify inaccurate information</li>
                <li>The right to erase your personal information</li>
                <li>The right to restrict processing of your personal information</li>
                <li>The right to data portability</li>
                <li>The right to object to processing</li>
              </ul>

              <h2>7. Children's Privacy</h2>
              <p>
                Our Service is not directed to individuals under the age of 16. We do not knowingly collect personal information from children under 16. If we become aware that we have collected personal information from a child under 16, we will take steps to delete such information.
              </p>

              <h2>8. Changes to This Privacy Policy</h2>
              <p>
                We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.
              </p>

              <h2>9. Contact Us</h2>
              <p>
                If you have any questions about this Privacy Policy, please contact us at privacy@agentspot.ai.
              </p>
            </motion.div>
          </div>
        </div>
      </section>
    </PageTransition>
  );
};

export default PrivacyPage;